module.exports = __webpack_public_path__ + "static/profile-pic-960c34e17adf94ad87f1db942d688dc7.jpg";